








































































































































































/* eslint-disable @typescript-eslint/naming-convention */

import { PropType, computed, defineComponent, ref, toRef } from '@nuxtjs/composition-api';
import { SfAlert, SfButton, SfHeading, SfLink, SfPrice } from '@storefront-ui/vue';

import AddToWishlist from '~/components/AddToWishlist.vue';
import HTMLContent from '~/components/HTMLContent.vue';
import ImageWithHover from '~/components/ImageWithHover.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useCartView, useHoverImage } from '~/composables';
import { getName as getProductName, getPrice as getProductPrice } from '~/modules/catalog/product/getters/productGetters';
import { CustomProduct, Preparations } from '~/modules/catalog/types';
import { useCart } from '~/modules/checkout/composables/useCart';
import { useUser } from '~/modules/customer/composables/useUser';
import useWishlist from '~/modules/wishlist/composables/useWishlist';
import { usePageStore } from '~/stores/page';
import AnalysisAvailableClinics from '../../AnalysisAvailableClinics.vue';
import ProductExtraInfo from '../../ProductExtraInfo.vue';
import ProductPreparations from '../../ProductPreparations.vue';

export default defineComponent({
  name: 'VirtualProduct',
  components: {
    HTMLContent,
    SfButton,
    SfHeading,
    SfPrice,
    SfAlert,
    SfLink,
    AddToWishlist,
    ProductPreparations,
    ProductExtraInfo,
    SkeletonLoader,
    AnalysisAvailableClinics,
    ImageWithHover,
  },
  transition: 'fade',
  props: {
    product: {
      type: [Object, null] as PropType<CustomProduct>,
      default: null,
    },
  },
  setup(props) {
    const qty = ref(1);
    const { parentRouteData } = usePageStore();
    const isAnalysisInPackage = computed(() => Boolean(parentRouteData));
    const product = toRef(props, 'product');
    const { addItem, cart, isInCart, error: cartError, loading: isCartLoading, canAddToCart } = useCart();
    const { removeItemAndSendNotification } = useCartView();
    const { isHovered, hoverImage, unhoverImage } = useHoverImage();

    const { isAuthenticated } = useUser();
    const { addOrRemoveItem, isInWishlist } = useWishlist();

    const analysesCount = computed(() => props.product?.analysis?.total_count);
    const productShortDescription = computed(() => props.product?.short_description?.html || '');
    const productAdditionalInfo = computed(() => props.product?.additional_info?.html || '');

    const productPrice = computed(() => getProductPrice(props.product).regular);
    const productSpecialPrice = computed(() => getProductPrice(props.product).special);
    const addToCartError = computed(() => cartError.value?.addItem?.message);

    const removeItemFromCart = () => {
      const cartItem = cart.value.items.find((item) => item.product.uid === product.value.uid);
      removeItemAndSendNotification(cartItem);
    };

    const isPackage = computed(() => props.product?.analysis_type === 'PACKAGE');

    const preparations = computed(() => {
      if (!props.product || !isPackage) return {};
      const { combined_before_test_preparations, combined_medication_preparations, combined_food_and_alcohol_preparations } = props.product;
      const data: Preparations = {
        before_test_preparations: combined_before_test_preparations,
        medication_preparations: combined_medication_preparations,
        food_and_alcohol_preparations: combined_food_and_alcohol_preparations,
      };
      return data;
    });

    const analysesListLink = computed(() => `/${product.value?.url_key}/analys`);

    return {
      analysesCount,
      addItem,
      removeItemFromCart,
      isInCart,
      addItemToWishlist: addOrRemoveItem,
      canAddToCart,
      isAuthenticated,
      isInWishlist: computed(() => isInWishlist({ product: props.product })),
      isCartLoading,
      productShortDescription,
      getProductName,
      productPrice,
      productSpecialPrice,
      qty,
      addToCartError,
      productAdditionalInfo,
      preparations,
      isPackage,
      analysesListLink,
      isAnalysisInPackage,
      isHovered,
      hoverImage,
      unhoverImage,
    };
  },
});
